export const findEmployeeByType = (employees, type) =>
  employees.find(
    (employee) => employee.employeeAssignment.assignmentType === type,
  );

export const FORMATTED_EMPLOYEES = {
  VP_GROWTH: {
    aboutMe:
      'I lead Growth at Belong, where I build systems to scale the marketplace and deliver better outcomes for homeowners and residents. I joined Belong in 2021 with a clear belief that the rental market is fundamentally broken and needs to be rebuilt from the ground up. Growing up in Mumbai and later studying at UC Berkeley meant moving homes multiple times, giving me firsthand insight into how fragmented and frustrating renting and property management can be. That lived experience shapes how I think, build, and lead at Belong every day.',
    assignmentType: 'VPOfGrowth',
    bannerImage:
      'https://s3-us-west-1.amazonaws.com/bln-prd-employee-banner-images/47148-a19d0e37922760ab',
    bannerImageUrl:
      'https://s3-us-west-1.amazonaws.com/bln-prd-employee-banner-images/47148-a19d0e37922760ab',
    college: 'UC Berkeley',
    firstName: 'Sparsh',
    lastName: 'Mehta',
    name: 'Sparsh Mehta',
    homeTown: '',
    jobTitle: 'VP Of Growth',
    memberSince: '2021-08-01T02:41:07.0561366+00:00',
    profileImage:
      'https://bln-prd-usr-pics.s3.us-west-1.amazonaws.com/white_bg_profile_sparsh.png',
    profileImageUrl:
      'https://bln-prd-usr-pics.s3.us-west-1.amazonaws.com/white_bg_profile_sparsh.png',
    quote:
      '"Do not go where the path may lead, go instead where there is no path and leave a trail" - Ralph Waldo Emerson',
    sourceType: 'Home',
    workEmail: 'smehta@belonghome.com',
  },
  HEAD_OF_EXPERIENCE: {
    aboutMe:
      'As the Head of Experience and Homecare at Belong, I’m dedicated to ensuring our members feel truly at home. My focus is on delivering exceptional care, seamless solutions, and a stress-free experience so that every home remains a place of comfort and joy.',
    assignmentType: 'HeadOfExperience',
    bannerImage:
      'https://s3-us-west-1.amazonaws.com/bln-prd-employee-banner-images/265367-fd5e91dea89ae948',
    bannerImageUrl:
      'https://s3-us-west-1.amazonaws.com/bln-prd-employee-banner-images/265367-fd5e91dea89ae948',
    college: 'Columbia',
    firstName: 'Tamara',
    lastName: 'Epelbaum',
    homeTown: '',
    jobTitle: 'Head Of Experience',
    memberSince: '2024-04-03T21:39:41.8223133+00:00',
    name: 'Tamara Epelbaum',
    profileImage:
      'https://bln-prd-usr-pics.s3.us-west-1.amazonaws.com/white_bg_profile_tami.png',
    profileImageUrl:
      'https://bln-prd-usr-pics.s3.us-west-1.amazonaws.com/white_bg_profile_tami.png',
    quote: '"Excellence is not a skill, it’s an attitude." – Ralph Marston',
    sourceType: 'Home',
    workEmail: 'tepelbaum@belonghome.com',
  },
};

export const betterRenewals = {
  title: 'Renewing Your Resident’s Lease',
  residentTitle: 'Let’s Renew Your Lease',
};

const bubbleTexts = {
  // These are milestones
  AgreementSigned: `Welcome, {{ customer.first_name }}! To start, let's set your home up for success by making sure we have everything we need to get your home\u00a0loved.`,
  InspectionScheduled: `Time to get your home ready to be loved, {{ customer.first_name }}! We'll put a plan in place to make sure it is ready to be shown and meets Belong's standards for quality and\u00a0care.`,
  InspectionCompleted: `Time to get your home ready to be loved, {{ customer.first_name }}! We'll put a plan in place to make sure it is ready to be shown and meets Belong's standards for quality and\u00a0care.`,
  PostInspectionProposalSent: `Your home's plan is ready for review, {{ customer.first_name }}. Once approved, we'll get right to work, and have your home loved in no\u00a0time.`,
  PostInspectionProposalApproved: `Sounds like a plan, {{ customer.first_name }}! We'll get right to work preparing your home for\u00a0love.`,
  ShowReady: `Now's the time to get your home ready for the big stage, {{ customer.first_name }}. We'll make sure it's shown in it's best\u00a0light.`,
  FullListingPublished: `It's show time, {{ customer.first_name }}! We'll chase every lead that comes your home's way, and send you weekly updates on\u00a0progress.`,
  LeaseExecuted: `Alright! We found someone to love your home, {{ customer.first_name }}! We'll get to work making sure their move-in goes\u00a0smoothly.`,
  MoveInReady: `Your home is all set for your new Residents to arrive, {{ customer.first_name }}. We can't wait to welcome\u00a0them!`,
  ResidentMovedIn: `Your home is feeling the love, {{ customer.first_name }}! Your Residents are settling in, and we're making sure they're well taken care\u00a0of.`,
  ManagingAdoptedResidents: `Your Residents are all set up with their Belong account, {{ customer.first_name }}. We're excited to take care of\u00a0them.`,
  ResidentGaveMoveOutNotice: `Looks like your Residents are moving on, {{ customer.first_name }}. Time for us to work our magic and find someone new to love your\u00a0home!`,

  // This is an event.
  LeaseRenewed: `Looks like your Residents really love your home, {{ customer.first_name }}! They've renewed their lease, and we've renewed our vows to make sure your home is cared\u00a0for.`,
  LeaseStarted: `We're always here to make sure you and your Residents are well taken care, {{ customer.first_name }}. Let me know if there's anything I can do for\u00a0you!`,
};

export const getBubbleText = (unit, timeline, userFirstName) => {
  if (unit?.basicInfo?.onboardingInfo?.notInterestedInBelongServices) {
    return `Thank you for letting me know, ${userFirstName}. We'll be in touch soon to discuss next steps (and see if there's anything we can do to change your\u00a0mind).`;
  }

  // All Text changes match a milestone except for LeaseRenewed
  let lastMilestoneOrRenewal;
  if (Array.isArray(timeline)) {
    for (const event of timeline) {
      if (event.timelineEventType === 'LeaseRenewed') {
        lastMilestoneOrRenewal = bubbleTexts.LeaseRenewed;

        break;
      }

      if (event.timelineEventType === 'LeaseStarted') {
        lastMilestoneOrRenewal = bubbleTexts.LeaseStarted;

        break;
      }

      // If event has milestones, check if one of them matches a bubble text.
      const milestoneMatch = event?.milestones?.find((milestone) => {
        return bubbleTexts[milestone.name];
      });

      if (milestoneMatch) {
        lastMilestoneOrRenewal = bubbleTexts[milestoneMatch.name];

        break;
      }
    }
  }

  return lastMilestoneOrRenewal?.replace(
    '{{ customer.first_name }}',
    userFirstName,
  );
};
